import { Component, OnInit } from '@angular/core';
import { ArticleService } from "../../services/article.service";
import {GLOBAL} from "../../services/GLOBAL";
import {CategoriaService} from '../../services/categoria.service';



@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.css']
})
export class ArticlesComponent implements OnInit {

  public global = GLOBAL;
  public articles: Array<any> = [];
  public url;
  public isArticlesLoading = true;
  public placeholderCards = [1, 2, 3, 4, 5, 6];
  public articleMediaLoaded: { [id: string]: boolean } = {};

  constructor(private _articleService: ArticleService) {
    this.url = GLOBAL.url;
  }

  ngOnInit(): void {
    this.data_articles();
  }

  data_articles() {
    this.isArticlesLoading = true;

    this._articleService.listar('').subscribe(
      response => {
        this.articles = response.articles || [];
        this.articleMediaLoaded = {};
        this.articles.forEach(article => {
          const mediaKey = article && (article._id || article.slug || article.banner);
          if (mediaKey) {
            this.articleMediaLoaded[mediaKey] = false;
          }
        });
        this.isArticlesLoading = false;
      },
      error => {
        this.isArticlesLoading = false;
      }
    );
  }

  isArticleMediaLoaded(id: any): boolean {
    return !!this.articleMediaLoaded[id];
  }

  onArticleMediaLoaded(id: any): void {
    if (!id) {
      return;
    }
    this.articleMediaLoaded[id] = true;
  }

}
